module.exports = __webpack_public_path__ + "static/media/complete-test-img.68bd76b0.jpg";